import React from 'react';
import PropTypes from 'prop-types';
import TextArea from 'react-expanding-textarea';
import { Col, FormGroup, FormFeedback, Input, Label } from 'reactstrap';
import classnames from 'classnames';

const FormInput = props => (
  <FormGroup row className={classnames(props.classNameContainer, 'form-group-row')}>
    <Label for={props.id} className="form-group-row__label">
      {props.required ? (
        <span>
          {props.label} <span className="text-orange">*</span>
        </span>
      ) : (
        props.label
      )}
    </Label>
    <Col className="form-group-row__col">
      {props.type === 'TextArea' ? (
        <TextArea
          className={classnames(props.className, 'form-control form-group-row__input')}
          id={props.id}
          onBlur={props.onBlur}
          onChange={props.onChange}
          placeholder={props.placeholder}
          required={props.required}
          value={props.value}
        />
      ) : (
        <Input
          className={classnames(props.className, 'form-group-row__input')}
          id={props.id}
          onBlur={props.onBlur}
          onChange={props.onChange}
          placeholder={props.placeholder}
          required={props.required}
          rows={props.rows}
          type={props.type}
          value={props.value}
        />
      )}

      {props.children}
      <FormFeedback>{props.error}</FormFeedback>
    </Col>
  </FormGroup>
);

FormInput.propTypes = {
  children: PropTypes.shape({}),
  className: PropTypes.string,
  classNameContainer: PropTypes.string,
  error: PropTypes.string,
  id: PropTypes.string,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  placeholder: PropTypes.string,
  required: PropTypes.bool,
  rows: PropTypes.number,
  type: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onBlur: PropTypes.func,
  onChange: PropTypes.func,
};

FormInput.defaultProps = {
  className: '',
  required: false,
  type: 'text',
};

export default FormInput;
